import { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { trackPageview } from '../../lib/Tracking';

type Props = RouteComponentProps;

export class LocationTracker extends Component<Props> {
  componentDidMount() {
    trackPageview(this.props.history.createHref(this.props.location));
  }

  componentDidUpdate(prevProps: Props) {
    const currentPage = this.props.history.createHref(this.props.location);
    const prevPage = prevProps.history.createHref(prevProps.location);

    if (currentPage !== prevPage) {
      trackPageview(currentPage);
    }
  }

  render() {
    /* istanbul ignore next */
    return this.props.children || null;
  }
}

export const LocationTrackerWithRouter = withRouter(LocationTracker);
